import { ActivityModelOTP } from 'types/shared'
import { DefaultValueResolver } from './helpers'
import { primitiveResolver } from './primitiveResolver'

const DEFAULT_OTP_LENGTH = 5

export const otpResolver: DefaultValueResolver = async (
  activityModel,
  context
) => {
  const activity = await primitiveResolver(activityModel, context)
  if (!activity) return null

  const otpModel = activityModel as ActivityModelOTP & { length?: number }
  const maxLength = otpModel.length ?? DEFAULT_OTP_LENGTH

  return {
    ...activity,
    des: activity.des.slice(0, maxLength)
  }
}
